<template>
  <div id="login-parceiro">
    <div class="card card-login">
      <div class="loader"></div>
      <div class="d-flex justify-content-center">
        <div class="card-icon">
          <i class="icofont-user-alt-7"></i>
        </div>
      </div>
      <div id="form">
        <h2 class="card-title text-center mt-1">Login</h2>
        <ValidationObserver ref="observer" class="row">
          <form @submit.prevent="login()">
            <pulse-loader
              :loading="loading"
              :color="color"
              :size="size"
              class="vue-loader"
            ></pulse-loader>
            <div class="col-12">
              <validation-provider v-slot="{ errors }" rules="required|cpf">
                <div class="form-group input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="icofont-card"></i>
                    </span>
                  </div>
                  <the-mask
                    :mask="['###.###.###-##']"
                    v-model="cpf"
                    class="form-control"
                    placeholder="CPF"
                    :disabled="!init"
                  />
                </div>
                <div class="error my-2">{{ errors[0] }}</div>
              </validation-provider>
            </div>
            <div class="col-12" v-if="verificandoUsuario && init">
              <b-alert show variant="primary">
                <b-spinner label="Spinning" small variant="primary"></b-spinner>
                Aguarde! Verificando usuário.
              </b-alert>
            </div>
            <div class="col-12" v-if="mais_de_uma_cidade && !init">
              <div class="form-group input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="icofont-location-pin"></i>
                  </span>
                </div>
                <select
                  class="form-control"
                  v-model="cidade"
                  @change="onChangeCidade($event)"
                  required
                >
                  <option value="" disabled>CIDADE</option>
                  <option
                    v-for="(item, index) in cidades"
                    :key="index"
                    :value="item.cidade.co_ibge + '-' + item.id_funcao"
                    :name="item.id_funcao"
                    :data-no_municipio="
                      item.cidade.no_municipio + ' - ' + item.cidade.no_uf
                    "
                  >
                    {{ item.cidade.no_municipio }} - {{ item.funcao }}
                  </option>
                </select>
              </div>
            </div>
            <div v-if="!init" class="col-12">
              <div class="form-group input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="icofont-lock"></i>
                  </span>
                </div>
                <input
                  name="senha"
                  v-model="senha"
                  class="form-control"
                  placeholder="SENHA"
                  :type="showPassword ? 'text' : 'password'"
                  required
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i
                      :class="
                        showPassword ? 'icofont-eye ' : 'icofont-eye-blocked'
                      "
                      @click="togglePasswordVisibility"
                      style="cursor: pointer"
                    ></i>
                  </span>
                </div>
              </div>
            </div>
            <!-- Microárea -->
            <div v-if="!init && id_funcao == '3'" class="col-12">
              <validation-provider
                v-slot="{ errors }"
                rules="required|inputMicroarea"
              >
                <div class="form-group input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="icofont-google-map"></i>
                    </span>
                  </div>
                  <the-mask
                    :mask="'##'"
                    v-model="micro_area"
                    class="form-control"
                    placeholder="MICROÁREA"
                  />
                </div>
                <div class="error my-2">{{ errors[0] }}</div>
              </validation-provider>
            </div>
            <div v-if="!init" class="col-12">
              <div class="d-flex justify-content-between">
                <span><i>Versão 8.6.1</i></span>
                <router-link to="/recuperar-senha"
                  >Esqueceu a senha?</router-link
                >
              </div>
            </div>
            <div v-if="init" class="col-12">
              <button
                class="btn float-right mt-0"
                @click.stop.prevent="buscarCidadesDoUsuario()"
                v-bind:disabled="btnLoginDisable"
              >
                <span v-if="!loadingBtn"> Continuar </span>
                <b-spinner
                  label="Spinning"
                  small
                  variant="white"
                  v-if="loadingBtn"
                ></b-spinner>
              </button>
            </div>
            <div v-else class="col-12 d-flex" style="gap: 15px">
              <button
                type="button"
                class="btn float-right"
                @click.stop.prevent="toGoBack()"
                v-bind:disabled="btnLoginDisable"
              >
                <span> Voltar </span>
              </button>
              <button
                type="submit"
                class="btn float-right"
                v-bind:disabled="btnLoginDisable"
              >
                <span v-if="!loadingBtn"> Entrar </span>

                <b-spinner
                  label="Spinning"
                  small
                  variant="white"
                  v-if="loadingBtn"
                ></b-spinner>
              </button>
            </div>
          </form>
        </ValidationObserver>
        <div class="col-12" v-if="init">
          <div class="links">
            Não tem conta?
            <router-link to="/criar-conta">Criar conta</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import Municipio from '@/services/Municipio.js'
import Equipe from '@/services/Equipe.js'
import Profissional from '@/services/Profissional.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()

export default {
  components: {
    TheMask,
    PulseLoader,
    ValidationObserver,
    ValidationProvider,
  },
  name: 'LoginParceiro',
  metaInfo: {
    title: 'Login',
    titleTemplate: null,
    meta: [
      { charset: 'utf-8' },
      {
        name: 'description',
        content:
          'Um painel de gestão para ajudar profissionais de saúde e gestores no atendimento aos requisitos do financimento federal da APS.',
      },
    ],
  },
  data() {
    return {
      showPassword: false,
      init: true,
      cpf: '',
      senha: '',
      cidade: '',
      cidades: [],
      no_municipio: '',
      micro_area: '',
      mais_de_uma_cidade: false,
      id_funcao: '',
      value_selected_multiselect: [],
      cidades_select: [],
      cidades_selected: [],
      loading: false,
      size: '40px',
      color: '#0D98BB',
      verificandoUsuario: false,
      btnLoginDisable: false,
      loadingBtn: false,
    }
  },
  mounted() {
    this.$store.dispatch('logout')
  },
  methods: {
    /**
     * Manipula ao selecionar uma cidade.
     *
     * @param {Object} event
     */
    onChangeCidade(event) {
      const selectedOption = event.target.options[event.target.selectedIndex]
      const idFuncao = selectedOption.getAttribute('name')
      const cidadeEstado = selectedOption.getAttribute('data-no_municipio')
      this.id_funcao = idFuncao
      this.$store.commit('setCidade', cidadeEstado)
      this.cidade = event.target.value
    },

    /**
     * Alterna a visibilidade do passsword
     */
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },

    /**
     * Volta a página
     */
    toGoBack() {
      this.init = true
      this.btnLoginDisable = false
      this.verificandoUsuario = false
    },

    /**
     * Realiza o login
     */
    async login() {
      try {
        let isValidForm = await this.$refs.observer.validate()
        if (!isValidForm) {
          return
        }

        if (this.cpf === '' || this.senha === '') {
          this.$toast.error('Preencha todos os campos!', 'Error:', {
            position: 'topRight',
          })
        } else if (this.mais_de_uma_cidade && this.cidade === '') {
          this.$toast.error('Selecione uma cidade!', 'Error:', {
            position: 'topRight',
          })
        } else {
          this.loadingBtn = true

          const cod_ibge = this.cidade.split('-')[0]

          //verifica se o município está ativo
          const statusMunicipio = await this.$apiPublic.get(
            '/faturamento/status/' + cod_ibge
          )
          if (statusMunicipio.data.status == '0') {
            this.$router.push('/municipio-negado')
            return
          }

          let url = '/web/login'
          const response = await this.$apiPublic.post(url, {
            cpf: this.cpf,
            senha: this.senha,
            cod_ibge: cod_ibge,
            id_funcao: this.id_funcao,
          })
          if (
            response.data.error == true &&
            response.data.message == 'USUÁRIO INATIVO!'
          ) {
            this.$router.push('/usuario-inativo')
            return
          }

          if (
            response.data.error == true &&
            response.data.message != 'USUÁRIO INATIVO!'
          ) {
            this.loading = false
            this.loadingBtn = false
            this.$toast.error(response.data.message, 'Error:', {
              position: 'topRight',
            })
            return
          }

          let token = response.data.token
          this.$store.commit('updateAccessToken', token)

          // valida o usuário
          const response2 = await this.$api.post('/app/auth/token')

          // Verifica se o usuário tem permissões
          if (response2.data.permissoes == false) {
            this.$toast.error(
              'Usuário sem permissões para acessar esse município! Entre em contato com o suporte.',
              'Error:',
              {
                position: 'topRight',
              }
            )
            return false
          }

          // Busca a ultima atualização do município
          const ultimaAtualizacao = this.$store.state.ultimaAtualizacao
          if (ultimaAtualizacao === null) {
            const responseUltimaAtualizacao =
              await Municipio.getUltimaAtualizacao(response2.data.cod_ibge)

            if (responseUltimaAtualizacao) {
              if (responseUltimaAtualizacao.data_sincronizacao != null) {
                this.$store.commit(
                  'setUltimaAtualizacao',
                  responseUltimaAtualizacao.data_sincronizacao
                    .split('-')
                    .reverse()
                    .join('/')
                )
              }
              if (responseUltimaAtualizacao.data_sincronizacao_c != null) {
                this.$store.commit('setSincronizadorC', {
                  ultimaAtualizacao:
                    responseUltimaAtualizacao.data_sincronizacao_c
                      .split('-')
                      .reverse()
                      .join('/'),
                  qtdDiasUltimaAtualizacao:
                    responseUltimaAtualizacao.qtd_dias_c,
                })
              }
            }
          }

          // Equipes V2 do município
          const responseEquipesV2 = await Municipio.getEquipesPorMunicipio(
            response2.data.cod_ibge
          )
          if (responseEquipesV2) {
            this.$store.commit('setEquipesV2', responseEquipesV2)
          }

          // Microáreas do município
          const responseMicroareasMunicipio =
            await Municipio.getMicroAreasPorMunicipio(response2.data.cod_ibge)
          if (responseMicroareasMunicipio) {
            this.$store.commit('setMicroAreas', responseMicroareasMunicipio)
          }

          // Regras indicadores APS
          const responseRegrasIndicadoresApsMunicipio =
            await Municipio.getRegrasIndicadoresPorMunicipio(
              response2.data.cod_ibge
            )
          if (responseRegrasIndicadoresApsMunicipio) {
            this.$store.commit(
              'setRegrasIndicadoresAps',
              responseRegrasIndicadoresApsMunicipio
            )
          }

          // Os últimos registros das tabelas sincronizadas
          const responseUltimosRegistrosTabelasSincronizadas =
            await Municipio.ultimosRegistrosTabelasSincronizadas(
              response2.data.cod_ibge
            )
          if (responseUltimosRegistrosTabelasSincronizadas) {
            this.$store.commit(
              'setUltimosRegistrosTabelasSincronizadas',
              responseUltimosRegistrosTabelasSincronizadas
            )
          }

          // armazena as informações do município
          let infoMunicipio = {
            exibe_logoefb: response2.data.infoMunicipio.exibe_logoefb,
            exibe_whatsapp: response2.data.infoMunicipio.exibe_whatsapp,
            logotipo: '',
            brasao: '',
            parceiro: response2.data.infoMunicipio.parceiro,
          }

          if (infoMunicipio.exibe_logoefb == '1') {
            infoMunicipio.logotipo = require('@/assets/images/logo.png')
          } else {
            if (response2.data.infoMunicipio.logotipo != null) {
              infoMunicipio.logotipo =
                this.$api.defaults.baseURL +
                '/uploads/logotipos/' +
                response2.data.infoMunicipio.logotipo
            }
          }

          // Define o brasão
          if (response2.data.infoMunicipio.brasao != null) {
            infoMunicipio.brasao =
              '/api/uploads/brasao/' + response2.data.infoMunicipio.brasao
          }

          this.$store.commit('setInfoMunicipio', infoMunicipio)

          this.$store.commit('setCodIbge', response2.data.cod_ibge)
          this.$store.commit('setIdFuncao', response2.data.id_funcao)
          this.$store.commit('setFuncao', response2.data.funcao)
          this.$store.commit('setUnidadeSaude', response2.data.unidade_saude)
          this.$store.commit('setId', response2.data.id)
          this.$store.commit('setUsername', response2.data.nome)
          this.$store.commit('setCoDimProf', response2.data.co_dim_prof)
          this.$store.commit(
            'setCosDimProf',
            response2.data.cos_dim_prof != null
              ? JSON.parse(response2.data.cos_dim_prof)
              : null
          )
          this.$store.commit('setPermissoes', response2.data.permissoes)
          this.$store.commit(
            'setUltimaAtualizacaoCadastro',
            response2.data.ultima_atualizacao_cadastro
          )
          this.$store.commit('setPdf', response2.data.pdf)
          this.$store.commit('setNpsEfb', response2.data.nps_efb)
          this.$store.commit('setFotoPerfil', response2.data.foto_perfil)

          sessionStorage.removeItem('aptoAvaliacaoNps')

          // Se o usuário for o secretário, administrador ou gerente/coordenador, farmácia e outros avança direto para o dashboard, caso contrário
          // verifica se o usuário está na tabela de profissionais de saúde
          if (
            response2.data.id_funcao == 1 ||
            response2.data.id_funcao == 2 ||
            response2.data.id_funcao == 7 ||
            response2.data.id_funcao == 9 ||
            response2.data.id_funcao == 10 ||
            response2.data.id_funcao == 11 ||
            response2.data.id_funcao == 12 ||
            response2.data.id_funcao == 13
          ) {
            let dataUltimaAtualizacaoCadastro = ''
            // Verifica se o usuário precisa atualizar o cadastro
            if (this.$store.state.ultimaAtualizacaoCadastro != null) {
              dataUltimaAtualizacaoCadastro =
                this.$store.state.ultimaAtualizacaoCadastro.split(' ')[0]
            }
            const resultado = this.diferencaMaiorQue6Meses(
              dataUltimaAtualizacaoCadastro.split('-').reverse().join('/')
            )
            if (
              this.$store.state.ultimaAtualizacaoCadastro == null ||
              resultado
            ) {
              await this.$store.commit('setRequiredPasswordUpdate', true)
              this.$router.push('/atualizacao-cadastro')
              return
            }

            this.$router.push('/dashboard')
          } else {
            // verifica o profissional
            const profissional = await this.$api.post(
              '/app/profissional-saude',
              {
                co_ibge: response2.data.cod_ibge,
                cpf: this.cpf.replace(/[^\d]+/g, ''),
              }
            )
            if (profissional.data == false) {
              this.$router.push('/acesso-negado')
            } else {
              this.$store.commit('setNuCns', response2.data.nu_cns)
              this.$store.commit('setNuIne', response2.data.nu_ine)
              this.$store.commit(
                'setNuIneVinculada',
                response2.data.nu_ine_vinculada
              )
              this.$store.commit('setNuCnes', response2.data.nu_cnes)
              this.$store.commit(
                'setUnidadeSaude',
                response2.data.unidade_saude
              )

              // Se for login do ACS, captura a microárea do form.
              if (response2.data.id_funcao == '3') {
                this.$store.commit('setMicroArea', this.micro_area)
              } else {
                this.$store.commit('setMicroArea', response2.data.micro_area)
              }

              // Verifica se o usuário precisa atualizar o cadastro
              let dataUltimaAtualizacaoCadastro = ''
              if (this.$store.state.ultimaAtualizacaoCadastro != null) {
                dataUltimaAtualizacaoCadastro =
                  this.$store.state.ultimaAtualizacaoCadastro.split(' ')[0]
              }
              const resultado = this.diferencaMaiorQue6Meses(
                dataUltimaAtualizacaoCadastro.split('-').reverse().join('/')
              )
              if (
                this.$store.state.ultimaAtualizacaoCadastro == null ||
                resultado
              ) {
                await this.$store.commit('setRequiredPasswordUpdate', true)
                this.$router.push('/atualizacao-cadastro')
                return
              }

              // Se for Médico, enfermeiro, odontólogo, téc. saúde bucal, emulti redireciona para a tela de escolher lotações, recepcionista
              if (
                response2.data.id_funcao == 4 ||
                response2.data.id_funcao == 5 ||
                response2.data.id_funcao == 8 ||
                response2.data.id_funcao == 14 ||
                response2.data.id_funcao == 15
              ) {
                // Se for recepcionista ou odontólogo e não tiver um ine,redireciona direto para o dashboard
                if (
                  (response2.data.id_funcao == 5 ||
                    response2.data.id_funcao == 8) &&
                  this.$store.state.nu_ine == ''
                ) {
                  this.$router.push('/dashboard')
                  return
                }
                this.$router.push(
                  '/lotacoes/' + response2.data.cod_ibge + '/' + this.cpf
                )
              } else {
                this.$router.push('/dashboard')
              }
            }
          }

          this.loading = false
          this.loadingBtn = false
        }
      } catch (error) {
        console.log(error)
        switch (error.response.status) {
          case 500:
            this.$toast.error(
              'Erro',
              'Serviço temporariamente indisponível. Por favor, tente novamente mais tarde.',
              {
                position: 'topRight',
              }
            )
            break
          default:
            this.$toast.error(
              'Erro',
              'Serviço temporariamente indisponível. Por favor, tente novamente mais tarde.',
              {
                position: 'topRight',
              }
            )
            break
        }
      }
    },

    /**
     * Busca as cidades do usuário
     */
    async buscarCidadesDoUsuario() {
      const isValidForm = await this.$refs.observer.validate()
      if (!isValidForm) return

      const cpf = (this.cpf || '').trim()
      if (!cpf) {
        this.$toast.error('Preencha o CPF!', 'Error:', { position: 'topRight' })
        return
      }

      this.btnLoginDisable = true
      this.verificandoUsuario = true

      // limpa estado relacionado à segunda etapa
      this.cidade = ''
      this.senha = ''
      this.id_funcao = ''
      this.mais_de_uma_cidade = false
      this.cidades = []

      try {
        const { data } = await this.$apiPublic.post('/usuario/cidades', { cpf })

        await new Promise((resolve) => setTimeout(resolve, 1000))

        this.$store.commit('setMunicipios', data)

        if (!Array.isArray(data) || data.length === 0) {
          this.$toast.error('Nenhum usuário encontrado.', 'Error:', {
            position: 'topRight',
          })
          return
        }

        // mais de uma cidade
        if (data.length > 1) {
          this.mais_de_uma_cidade = true
          this.cidades = data
          return
        }

        // apenas uma cidade
        const item = data[0]
        const cidade = item?.cidade

        this.mais_de_uma_cidade = false
        this.cidade = cidade?.co_ibge || ''

        const nomeCidade = [cidade?.no_municipio, cidade?.no_uf]
          .filter(Boolean)
          .join(' - ')

        this.$store.commit('setCidade', nomeCidade)

        if (String(item?.id_funcao) === '3') {
          this.id_funcao = String(item.id_funcao)
        }
      } catch (error) {
        console.log(error)
        this.$toast.error('Erro ao buscar cidades do usuário.', 'Error:', {
          position: 'topRight',
        })
      } finally {
        this.init = false
        this.btnLoginDisable = false
        this.verificandoUsuario = false
      }
    },

    /**
     * Verifica a diferença de dias
     *
     * @param {String} dataComparacao
     * @returns {Boolean}
     */
    diferencaMaiorQue6Meses(dataComparacao) {
      if (dataComparacao == null) {
        return true
      }

      // Obtém a data atual
      const dataAtual = new Date()

      // Divide a data atual em dia, mês e ano
      const diaAtual = dataAtual.getDate()
      const mesAtual = dataAtual.getMonth() + 1 // Os meses em JavaScript são baseados em zero
      const anoAtual = dataAtual.getFullYear()

      // Divide a data de comparação em dia, mês e ano
      const partesData = dataComparacao.split('/')
      const diaComparacao = parseInt(partesData[0], 10)
      const mesComparacao = parseInt(partesData[1], 10)
      const anoComparacao = parseInt(partesData[2], 10)

      // Calcula a diferença em meses
      const diferencaMeses =
        (anoAtual - anoComparacao) * 12 + (mesAtual - mesComparacao)

      // Verifica se a diferença é maior do que 6 meses
      return diferencaMeses > 6
    },
  },
}
</script>

<style>
#login-parceiro {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

form {
  width: 100%;
}

.card-login {
  width: 400px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding: 1.85rem;
  position: relative;
  margin: 0px auto;
  border-radius: 10px;
}

.card-icon i {
  font-size: 50px;
  line-height: 100px;
  text-align: center;
}

#login-parceiro .card-icon {
  position: relative;
  top: 0;
  height: 120px;
  width: 120px;
  border-radius: 50%;
  background: #f9f9f9;
  padding: 10px;
  text-align: center;
}

.card-title {
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  font-size: 17px;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 10px;
  text-align: center;
}

.btn-create-account {
  background-color: #0fafd7;
  border-color: #bf00dc;
  color: #fff;
  border-radius: 10rem;
  font-size: 0.838rem;
  font-weight: 500;
  padding: 0.55em 1.735em;
  line-height: 1.75em;
  width: 200px;
  display: inline-block;
  text-align: center;
  text-transform: uppercase;
  margin-right: 20px;
}

.card-login .btn {
  height: 40px;
  width: 100%;
  border-radius: 32px;
  display: inline-block;
  background-color: #0fafd7;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  margin-top: 10px;
}

@media screen and (max-width: 656px) {
}

@media screen and (min-width: 657px) and (max-width: 807px) {
}

@media screen and (min-width: 808px) and (max-width: 1023px) {
}

@media screen and (min-width: 1024px) and (max-width: 1265px) {
}

.links {
  flex-direction: row !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 10px 0 0 0;
  gap: 5px;
}

.links p {
  text-align: center;
  margin-bottom: 0;
  color: #000;
  font-size: 16px;
}

.links p a {
  margin: 0 auto;
}
</style>
